import { DocumentNode, gql } from '@apollo/client';
import {
  Avatar,
  HStack,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  StackDivider,
  Text,
  VStack,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { VotesModal_PollOptionFragment } from './graphql-types/VotesModal_PollOptionFragment';

export const VotesModal: React.FC<
  Omit<ModalProps, 'children'> & {
    option: VotesModal_PollOptionFragment;
  }
> & {
  pollOptionFragment: DocumentNode;
} = ({ option, ...modalProps }) => {
  return (
    <Modal size="xl" isCentered scrollBehavior="inside" {...modalProps}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader noOfLines={1} overflow="unset">
          Votes for {option.description}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack
            divider={<StackDivider />}
            spacing="4"
            pb="4"
            align="flex-start"
          >
            {option?.responses?.map((response) => {
              return (
                <HStack key={response._id}>
                  <NextLink href={`/members/${response.user._id}`}>
                    <Avatar
                      size="md"
                      name={response.user.displayName}
                      src={response.user.proxyProfilePictureUrl || undefined}
                    />
                  </NextLink>
                  <Text fontWeight="600" color="gray.700" aria-hidden={true}>
                    {response.user.displayName}
                  </Text>
                </HStack>
              );
            })}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

VotesModal.pollOptionFragment = gql`
  fragment VotesModal_PollOptionFragment on PollOption {
    _id
    description
    responseCount
    responses {
      _id
      user {
        _id
        displayName
        proxyProfilePictureUrl(
          input: { w: 48, h: 48, fit: "facearea", facepad: 10.0 }
        )
      }
    }
  }
`;
